// JS
import '../../custom/js/index';

// JS Components
import FormTools from '../../custom/js/utils/formTools';

// Base SCSS
import '../../custom/scss/base.scss';

// Components SCSS
import '../../custom/scss/components/content/content-hero.scss';
import '../../custom/scss/components/form/form.scss';
import '../../custom/scss/components/content/content-detail.scss';

// Pages
import '../../custom/scss/pages/contact.scss';

window.FormTools = new FormTools();

$(() => {
    window.FormTools.init();
});